import React from 'react';
import { AD_LIGHT_BOOTSTRAP_SCRIPT, AD_LIGHT_CRITICAL_CSS } from '@benzinga/ads-utils';

export const AD_LIGHT_BOOTSTRAP_SCRIPT_ID = 'bz-adlight-bootstrap';
export const AD_LIGHT_CRITICAL_CSS_ID = 'bz-adlight-critical-css';

export const AdLightBootstrapScript: React.FC = () => (
  <>
    <style dangerouslySetInnerHTML={{ __html: AD_LIGHT_CRITICAL_CSS }} id={AD_LIGHT_CRITICAL_CSS_ID} />
    <script
      dangerouslySetInnerHTML={{ __html: AD_LIGHT_BOOTSTRAP_SCRIPT }}
      data-cfasync="false"
      id={AD_LIGHT_BOOTSTRAP_SCRIPT_ID}
    />
  </>
);
